import type { TFunction } from "i18next";

export const getFileDropErrorMessage = (code: string, t: TFunction): string => {
    switch (code) {
        case "file-invalid-type":
            return t("common:fileDrop.invalidType");
        case "file-too-large":
            return t("common:fileDrop.tooLarge");
        case "file-too-small":
            return t("common:fileDrop.tooSmall");
        case "too-many-files":
            return t("common:fileDrop.tooMany");
        default:
            return t("common:fileDrop.genericError");
    }
};
